import { useEffect } from 'react';

interface ToastProps {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  onClose: () => void;
  duration?: number;
}

export default function Toast({ type, message, onClose, duration = 3000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const styles = {
    success: 'bg-green-50 border-green-500 text-green-800',
    error: 'bg-red-50 border-red-500 text-red-800',
    warning: 'bg-orange-50 border-orange-500 text-orange-800',
    info: 'bg-blue-50 border-blue-500 text-blue-800'
  };

  const icons = {
    success: 'ri-checkbox-circle-line text-green-600',
    error: 'ri-error-warning-line text-red-600',
    warning: 'ri-alert-line text-orange-600',
    info: 'ri-information-line text-blue-600'
  };

  return (
    <div className={`fixed top-4 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-lg border-l-4 shadow-lg ${styles[type]} animate-slide-in-right`}>
      <i className={`${icons[type]} text-xl w-5 h-5 flex items-center justify-center`}></i>
      <p className="text-sm font-medium">{message}</p>
      <button
        onClick={onClose}
        className="ml-2 hover:opacity-70 transition-opacity"
      >
        <i className="ri-close-line text-lg w-4 h-4 flex items-center justify-center"></i>
      </button>
    </div>
  );
}